import { combineReducers } from 'redux'
import authorizationProviderReducer from '../../containers/AuthorizationProvider/AuthorizationProvider.reducer'
import registerWizardReducer from '../../containers/RegisterWizard/RegisterWizard.reducer'
import taxesKeyAuthReducer from '../../containers/TaxesKeyAuth/TaxesKeyAuth.reducer'
import uniquePassAuthReducer from '../../containers/UniquePassAuth/UniquePassAuth.reducer'
import recaptchaReducer from '../../containers/Recaptcha/recaptcha.reducer'

export default combineReducers({
  authorizationProvider: authorizationProviderReducer,
  registerWizard: registerWizardReducer,
  taxesKeyAuth: taxesKeyAuthReducer,
  uniquePassAuth: uniquePassAuthReducer,
  recaptcha: recaptchaReducer
})
